import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { FcCalendar, FcList } from "react-icons/fc";
import { useLocation, useNavigate } from "react-router-dom";

export const SubmenuPermitPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Perizinan",
    });
  }, [setHeader]);
  return (
    <div className="tw-p-4 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.PERMIT_PAGE)}
            className="tw-m-0"
          >
            <FcCalendar
              className="card-icon"
              style={{ background: "#f7dbd9" }}
            />
            <div className="tw-mt-0 card-name">Request</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.PERMIT_DATA_PAGE)}
            className="tw-m-0"
          >
            <FcList className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Laporan</div>
          </div>
        </div>
      </div>
    </div>
  );
};
